import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { AgentService } from '../services/agent.service';
import { AgentHierarchyBranchSearchHandler } from './agent-hierarchy-branch-search.handler';
import { SettingService } from 'src/app/system-common/services/setting.service';

@Component({
  selector: 'sym-agent-hierarchy-branch-search',
  templateUrl: './agent-hierarchy-branch-search.component.html',
  styleUrls: ['./agent-hierarchy-branch-search.component.scss'],
})
export class AgentHierarchyBranchSearchComponent extends AgentHierarchyBranchSearchHandler {
  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, headerService, router, settingService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
